module.exports = __webpack_public_path__ + "img/Bartosz.b7e39adf.jpg";